<div class="survey-listing-container">
  
  <!-- Header -->
  <div class="page-header">
    <h2>
      <i class="fas fa-clipboard-check"></i>
      Customer Survey Management
      <!-- <span class="badge badge-info ml-2">{{ isHROrAdmin() ? 'HR/Admin' : 'Employee' }}</span> -->
    </h2>
    <div class="header-actions">
      <button *ngIf="isHROrAdmin()" 
              class="btn btn-primary" 
              (click)="createNewSurvey()">
        <i class="fas fa-plus"></i> Create Survey Assignment
      </button>
    </div>
  </div>

  <!-- Alert Messages -->
  <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
    <i class="fas fa-check-circle"></i> {{ successMessage }}
    <button type="button" class="close" (click)="successMessage = ''">
      <span>&times;</span>
    </button>
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
    <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
    <button type="button" class="close" (click)="errorMessage = ''">
      <span>&times;</span>
    </button>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="loading" class="loading-container text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <p class="mt-2 text-muted">Loading survey assignments...</p>
  </div>

  <!-- Main Content -->
  <div *ngIf="!loading">
    
    <!-- Filters Card -->
    <div class="card mb-4">
      <div class="card-header">
        <h5><i class="fas fa-filter"></i> Filters</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-2">
            <label>Status</label>
            <select [(ngModel)]="filters.status" class="form-control">
              <option value="">All</option>
              <option value="Pending">Pending</option>
              <option value="In Progress">In Progress</option>
              <option value="Completed">Completed</option>
            </select>
          </div>
          
          <!-- Employee Filter (Only for HR/Admin) -->
          <div class="col-md-3" *ngIf="isHROrAdmin()">
            <label>Employee</label>
            <select [(ngModel)]="filters.employee_id" class="form-control">
              <option value="">All Employees</option>
              <option *ngFor="let employee of employees" [value]="employee.employee_id">
                {{ employee.employee_name }}
              </option>
            </select>
          </div>
          
          <div class="col-md-2">
            <label>Customer Type</label>
            <select [(ngModel)]="filters.customer_type" class="form-control">
              <option value="">All Types</option>
              <option *ngFor="let type of customerTypes" [value]="type">
                {{ type }}
              </option>
            </select>
          </div>
          
          <div class="col-md-2">
            <label>From Date</label>
            <input type="date" [(ngModel)]="filters.from_date" class="form-control">
          </div>
          
          <div class="col-md-2">
            <label>To Date</label>
            <input type="date" [(ngModel)]="filters.to_date" class="form-control">
          </div>
          
          <div class="col-md-1 d-flex align-items-end">
            <button type="button" class="btn btn-primary btn-block" (click)="applyFilters()">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12 text-right">
            <button type="button" class="btn btn-secondary btn-sm" (click)="clearFilters()">
              <i class="fas fa-times"></i> Clear Filters
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Survey Assignments List -->
    <div class="card">
      <div class="card-header">
        <h5>
          <i class="fas fa-tasks"></i> 
          {{ isHROrAdmin() ? 'All Survey Assignments' : 'My Assigned Surveys' }} 
          ({{ totalCount }})
        </h5>
      </div>
      <div class="card-body">
        
        <!-- Table View -->
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Survey #</th>
                <th>Created by</th>
                <th>Created Date</th>
                <th>Customers</th>
                <th>Progress</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let survey of surveyAssignments">
                <td>
                  <strong>{{ survey.survey_number }}</strong>
                  <br>
                  <small class="text-muted">{{ survey.survey_title }}</small>
                </td>
                <td>
                  <!-- Option 1: Show survey creator -->
                  <i class="fas fa-user-edit"></i>
                  {{ survey.created_by?.employee_name || 'Unknown' }}
                  <br>
                  <small class="text-muted">Created by</small>
                  
                  <!-- OR Option 2: Show assigned employees count -->
                  <!-- 
                  <i class="fas fa-users"></i>
                  {{ getAssignedEmployeeCount(survey) }} employees
                  <br>
                  <small class="text-muted">Assigned</small>
                  -->
                </td>
                <td>{{ formatDate(survey.created_date_time) }}</td>
                <td>
                  <span class="badge badge-secondary">
                    {{ survey.total_assigned || 0 }} customers
                  </span>
                  <br>
                  <span class="badge badge-success">
                    {{ survey.total_completed || 0 }} completed
                  </span>
                </td>
                <td>
                  <div class="progress" style="height: 25px;">
                    <div class="progress-bar" 
                         [class.bg-success]="getCompletionPercentage(survey) === 100"
                         [class.bg-info]="getCompletionPercentage(survey) < 100 && getCompletionPercentage(survey) > 0"
                         [class.bg-warning]="getCompletionPercentage(survey) === 0"
                         [style.width.%]="getCompletionPercentage(survey)"
                         role="progressbar">
                      {{ survey.total_completed || 0 }}/{{ survey.total_assigned || 0 }}
                      ({{ getCompletionPercentage(survey) }}%)
                    </div>
                  </div>
                </td>
                <td>
                  <span class="badge" [ngClass]="getStatusClass(survey.status)">
                    {{ survey.status }}
                  </span>
                </td>
                <td>
                  <button class="btn btn-sm btn-info" 
        (click)="viewDetail(survey.survey_id)"
        title="View Details">
  <i class="fas fa-eye"></i> View
</button>
                  
                  <!-- HR/Admin: Delete Button (commented out as requested) -->
                  <!-- 
                  <button *ngIf="isHROrAdmin()" 
                          class="btn btn-sm btn-danger" 
                          (click)="deleteAssignment(survey.survey_id)"
                          title="Delete Assignment">
                    <i class="fas fa-trash"></i>
                  </button>
                  -->
                </td>
              </tr>
              <tr *ngIf="surveyAssignments.length === 0">
                <td colspan="7" class="text-center text-muted py-5">
                  <i class="fas fa-inbox fa-4x mb-3 d-block"></i>
                  <h5>{{ isHROrAdmin() ? 'No survey assignments found' : 'You have no assigned surveys' }}</h5>
                  <p *ngIf="isHROrAdmin()">Click "Create Survey Assignment" to get started.</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="pagination-container mt-4" *ngIf="totalPages > 1">
          <div class="row">
            <div class="col-md-6">
              <div class="pagination-info">
                Showing {{ startRecord }} to {{ endRecord }} of {{ totalCount }} records
              </div>
            </div>
            <div class="col-md-6">
              <nav>
                <ul class="pagination justify-content-end mb-0">
                  <li class="page-item" [class.disabled]="currentPage === 0">
                    <a class="page-link" (click)="previousPage()">
                      <i class="fas fa-chevron-left"></i> Previous
                    </a>
                  </li>
                  <li class="page-item" 
                      *ngFor="let page of [].constructor(totalPages); let i = index"
                      [class.active]="i === currentPage">
                    <a class="page-link" (click)="goToPage(i)">{{ i + 1 }}</a>
                  </li>
                  <li class="page-item" [class.disabled]="currentPage === totalPages - 1">
                    <a class="page-link" (click)="nextPage()">
                      Next <i class="fas fa-chevron-right"></i>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Info Card for Employees -->
    <div *ngIf="!isHROrAdmin() && surveyAssignments.length > 0" class="card mt-4 bg-light">
      <div class="card-body">
        <h6><i class="fas fa-info-circle"></i> Instructions for Employees:</h6>
        <ul class="mb-0">
          <li>Click "View" to see survey details and assigned customers</li>
          <li>Submit survey responses for each assigned customer</li>
          <li>Complete all customer surveys to finish the assignment</li>
        </ul>
      </div>
    </div>

  </div>

</div>